import * as React from 'react';
import type { JsonObject } from '@/app-package';
import { AnsweringOrgGroupDoc, OrgDoc } from '@bb/domain/dist/schemas';

interface BrokerageGroupingSelectProps {
  groups: (Omit<JsonObject<AnsweringOrgGroupDoc>, 'orgs'> & {
    orgs: JsonObject<OrgDoc>[];
  })[];
  handleChange: ({ id, orgId }: { id: string; orgId: string }) => void;
  orgId: string;
  pending: boolean;
}

interface BrokerageGroupingSelectState {
  currentValue: string;
}

class BrokerageGroupingSelect extends React.Component<
  BrokerageGroupingSelectProps,
  BrokerageGroupingSelectState
> {
  constructor(props: BrokerageGroupingSelectProps) {
    super(props);
    this.state = { currentValue: '' };
  }

  public componentDidMount() {
    // Set default values
    const { groups, orgId } = this.props;
    const foundGroup = groups.find(group =>
      Boolean(group.orgs.find(org => org.id === orgId)),
    );
    const defaultId = foundGroup ? foundGroup.id : '';
    this.setState({ currentValue: defaultId });
  }

  public _handleChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    const { handleChange, orgId } = this.props;
    this.setState({ currentValue: ev.target.value }, () => {
      handleChange({ id: this.state.currentValue, orgId });
    });
  };

  public render() {
    const { currentValue } = this.state;
    const { groups, pending } = this.props;
    return (
      <select
        onChange={this._handleChange}
        className="form-control"
        disabled={pending}
        value={currentValue}
      >
        <option key="default" value={''}></option>
        {groups.map(group => (
          <option key={group.id} value={group.id}>
            {group.label}
          </option>
        ))}
      </select>
    );
  }
}

export default BrokerageGroupingSelect;
